import React from 'react';
import moment from 'moment';
import './TableUserInfo.scss';

function formatDateTime(v) {
  if (!v) return '-';
  try {
    // numeric ms or seconds
    if (typeof v === 'number') return moment(v).format('DD/MM/yyyy HH:mm');
    const s = String(v);
    if (/^\d+$/.test(s)) {
      const num = Number(s);
      // assume ms if big enough
      const ms = num > 1e12 ? num : num * 1000;
      return moment(ms).format('DD/MM/yyyy HH:mm');
    }
    // ISO or readable string
    const d = new Date(s);
    if (!isNaN(d.getTime())) return moment(d.getTime()).format('DD/MM/yyyy HH:mm');
    return s;
  } catch (_) {
    return String(v);
  }
}

export default function SubscriptionDetailsTable({ subscription }) {
  if (!subscription) {
    return <div className="no-data">No data</div>;
  }
  const { id, plan_id, status, lastPayment, nextBillingTime, price, currency, planName, planType } = subscription || {};
  return (
    <div className="TableUserInfo-container" style={{ marginTop: 12 }}>
      <table>
        <thead>
          <tr>
            <th>Subscription ID</th>
            <th>Plan ID</th>
            <th>Status</th>
            <th>Last Payment</th>
            <th>Next Billing</th>
            <th>Price</th>
            <th>Currency</th>
            <th>Plan Name</th>
            <th>Plan Type</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="tableBox_S">{id || '-'}</td>
            <td className="tableBox_S">{plan_id || '-'}</td>
            <td className="tableBox_S">{status || '-'}</td>
            <td className="tableBox_S">{formatDateTime(lastPayment)}</td>
            <td className="tableBox_S">{formatDateTime(nextBillingTime)}</td>
            <td className="tableBox_S">{price || '-'}</td>
            <td className="tableBox_S">{currency || '-'}</td>
            <td className="tableBox_S">{planName || '-'}</td>
            <td className="tableBox_S">{planType || '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}


